// @ts-nocheck
import Attribute from '@/components/ui/attribute';
import Scrollbar from '@/components/ui/scrollbar';
import { useProductVariants } from '@/framework/product-variants';
import { Routes } from '@/config/routes';
import type { ISearchProduct } from '@/types';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { flushSync } from 'react-dom';
import { skipNextModalHistoryCleanup } from '@/components/ui/modal/history-cleanup';
import { useModalAction } from '@/components/ui/modal/modal.context';

const VARIANT_TYPE_LABELS: Record<string, string> = {
  dosage: 'Dosagem:',
  quantity: 'Quantidade:',
  custom: '',
};

type Props = {
  product: ISearchProduct;
  isModal?: boolean;
  className?: string;
};

const ProductVariants: React.FC<Props> = ({
  product,
  isModal = false,
  className,
}) => {
  const router = useRouter();
  const { closeModal } = useModalAction();
  const { data: variantGroup, isLoading } = useProductVariants({
    productId: product?.product_id,
    variantGroupId: product?.variant_group_id,
  });

  if (isLoading || !variantGroup || variantGroup.items.length < 2) {
    return null;
  }

  const sectionLabel =
    variantGroup.variant_type === 'custom'
      ? `${variantGroup.variant_type_label || 'Opcao'}:`
      : VARIANT_TYPE_LABELS[variantGroup.variant_type] ??
      VARIANT_TYPE_LABELS.dosage;

  const navigate = (slug: string, sku: string) => {
    const path = Routes.product(slug, `${sku}`);
    if (isModal) {
      skipNextModalHistoryCleanup();
      flushSync(() => {
        closeModal();
      });
      void router.replace(path);
    } else {
      void router.push(path);
    }
  };

  return (
    <div className={classNames('mt-5', className)}>
      <div className="flex items-center py-2.5">
        {sectionLabel ? (
          <span className="me-3 inline-block min-w-[72px] shrink-0 whitespace-nowrap text-base font-semibold text-gray-600">
            {sectionLabel}
          </span>
        ) : null}
        <div
          className={classNames('w-full overflow-hidden', {
            '-mb-4': sectionLabel,
          })}
        >
          <Scrollbar
            className="w-full pb-4"
            options={{
              scrollbars: {
                autoHide: 'never',
              },
            }}
          >
            <div className="flex w-full flex-wrap gap-1.5 sm:flex-nowrap">
              {variantGroup.items.map((item) => {
                const isActive =
                  Number(item.product_id) === Number(product.product_id);
                return (
                  <Attribute
                    key={item.product_id}
                    variant="outline"
                    size="sm"
                    value={item.label}
                    isActive={isActive}
                    className={classNames({
                      'ring-1 ring-accent/30': isActive,
                    })}
                    onClick={() => {
                      if (!isActive) {
                        navigate(item.slug, item.sku);
                      }
                    }}
                  />
                );
              })}
            </div>
          </Scrollbar>
        </div>
      </div>
    </div>
  );
};

export default ProductVariants;
